import { BackTestInputs } from 'components/common-form/sidePanel/backTest/BackTestInputs';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import {
  removeSecondBackTestQuoteId,
  runBackTest,
  setBackTestMaturitiesMode,
  setInitialBackTestQuoteLabel,
  setMaturities,
  setSecondBackTestQuoteId,
  setSecondBackTestQuoteLabel,
} from 'state/backTest/backTest.actions';
import type { BackTestModel, DateMode } from 'state/backTest/backTest.model';
import {
  getBackTestByTabId,
  hasErrorForInitialQuoteId,
  hasErrorForSecondQuoteId,
  hasRunBackTest,
} from 'state/backTest/backTest.selector';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export type StateProps = Pick<
  BackTestModel,
  'canAddExtraQuote' | 'maturities' | 'quoteLabels' | 'quoteIds' | 'maturityMode'
> & { hasRunBackTest: boolean; hasErrorForSecondQuoteId: boolean; hasErrorForInitialQuoteId: boolean };

export type OwnProps = FormOwnProps;

export type DispatchProps = {
  addSecondQuoteId: () => void;
  setSecondQuoteId: (quoteId: string) => void;
  setInitialQuoteLabel: (quoteLabel?: string) => void;
  setSecondQuoteLabel: (quoteLabel?: string) => void;
  removeSecondQuoteId: () => void;
  setMaturities: (maturities: readonly string[]) => void;
  setMaturityMode: (mode: DateMode) => void;
  runTest: () => void;
};

export type BackTestInputsProps = StateProps & OwnProps & DispatchProps;
const mapStateToProps = (state: AppState, { formId }: OwnProps): StateProps => {
  return {
    ...getBackTestByTabId(state, formId)!,
    hasRunBackTest: hasRunBackTest(state, formId),
    hasErrorForInitialQuoteId: hasErrorForInitialQuoteId(state, formId),
    hasErrorForSecondQuoteId: hasErrorForSecondQuoteId(state, formId),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { formId: tabId }: OwnProps): DispatchProps => ({
  addSecondQuoteId() {
    dispatch(setSecondBackTestQuoteId(tabId, null));
  },
  setSecondQuoteId(quoteId) {
    dispatch(setSecondBackTestQuoteId(tabId, quoteId));
  },
  setInitialQuoteLabel(quoteLabel) {
    dispatch(setInitialBackTestQuoteLabel(tabId, quoteLabel));
  },
  setSecondQuoteLabel(quoteLabel) {
    dispatch(setSecondBackTestQuoteLabel(tabId, quoteLabel));
  },
  removeSecondQuoteId() {
    dispatch(removeSecondBackTestQuoteId(tabId));
  },
  setMaturities(maturities) {
    dispatch(setMaturities(tabId, maturities));
  },
  setMaturityMode(mode) {
    dispatch(setBackTestMaturitiesMode(tabId, mode));
  },
  runTest() {
    dispatch(runBackTest(tabId));
  },
});

export const ConnectedBackTestInputs = connect(mapStateToProps, mapDispatchToProps)(BackTestInputs);
